<template>
  <v-card elevation="0" class="mt-2">
    <v-card-title>Accounts I Am Authorized On</v-card-title>
    <v-card-text id="data-table">
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="10"
        class="elevation-1"
        :single-expand="true"
        expand-icon="mdi-menu-right"
        :expanded.sync="expanded"
        item-key="account_name"
        show-expand
      >
        <template v-slot:item.actions="{ item }">
          <v-dialog v-model="dialog2" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom v-bind="attrs" v-on="on">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="setUserForRecordAssociation(item)"
                    v-if="!item.is_associated"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-link
                    </v-icon>
                  </v-btn>
                </template>
                <span>Associate a record with this account</span>
              </v-tooltip>
            </template>
            <associaterecordpicker
              @closedialog2="closeDialog2()"
              :user="UserForRecordAssociation"
            />
          </v-dialog>

          <v-btn v-if="item.am_delegate" @click="addAuthorizeUser(item)" icon>
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>

          <v-btn v-if="item.am_delegate" @click="removeUserAccess(item)" icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-if="item.am_delegate"
            @click="openToggleDelegateModal(item)"
            icon
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.is_associated="{ item }">
          <div v-if="item.is_associated">
            <v-icon color="success">mdi-check</v-icon>
          </div>
          <div v-else>
            <v-icon color="error">mdi-close</v-icon>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <span>Users with access to this record:&nbsp;</span>
            <span v-for="(acl, index) in item.acls" :key="acl.username">
              <!-- prettier-ignore -->
              <span class="text-body-2 font-weight-medium">{{ acl.username }}</span>
              <!-- prettier-ignore -->
              <span v-if="acl.delegate" class="text-body-2 font-weight-thin"> (delegate)</span>
              <span>{{ index !== item.acls.length - 1 ? ", " : "" }}</span>
            </span>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import associaterecordpicker from "./associaterecordpicker.vue";
export default {
  props: { users: Array, currentUser: Object },
  components: { associaterecordpicker },
  computed: {},
  data() {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false,
      expanded: [],
      usertolookataclsaclsArr: [],
      UserForRecordAssociation: [],
      headers: [
        {
          text: "Authorized Users",
          align: "start",
          sortable: false,
          value: "account_name"
        },
        {
          text: "Delegate",
          align: "start",
          sortable: false,
          value: "am_delegate"
        },
        { text: "Actions", value: "actions", sortable: false },
        {
          text: "Associated",
          align: "start",
          sortable: false,
          value: "is_associated"
        }
      ]
    };
  },
  methods: {
    setUserForAcls(item) {
      this.usertolookataclsaclsArr = item.acls;
    },
    setUserForRecordAssociation(item) {
      this.UserForRecordAssociation = item;
      this.dialog2 = true;
    },
    addAuthorizeUser(item) {
      this.$emit("addAuthorizeUser", item);
    },
    removeUserAccess(item) {
      this.$emit("removeUserAccess", item);
    },
    openToggleDelegateModal(item) {
      this.$emit("opentoggledelegatemodal", item);
    },
    closeDialog2() {
      this.dialog2 = false;
      this.$emit("reloadusers");
    }
  }
};
</script>

<style lang="scss">
#data-table .v-data-table__expand-icon--active {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
#data-table
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
